module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Food/Cheese-78f83f860e573a5657554e54d837c287.svg";